/* Arjit4Amply: Journal topic filters (sections/matre-journal.liquid), ported
   from the mockup's journal-page.js: buttons toggle aria-pressed, cards
   outside the topic are hidden, the heading and count follow, and
   ?topic=sleep|energy|ingredients|rituals|matre preselects a topic. */
(function () {
  var buttons = Array.prototype.slice.call(document.querySelectorAll('[data-journal-filter]'));
  if (!buttons.length) return;
  var title = document.getElementById('journal-results-title');
  var countEl = document.getElementById('journal-count');

  function applyFilter(index) {
    var count = 0;
    buttons.forEach(function (b) {
      b.setAttribute('aria-pressed', String(Number(b.dataset.journalFilter) === index));
    });
    document.querySelectorAll('[data-journal-topic]').forEach(function (card) {
      card.hidden = index !== 0 && Number(card.dataset.journalTopic) !== index;
      if (!card.hidden) count++;
    });
    var active = buttons.filter(function (b) {
      return Number(b.dataset.journalFilter) === index;
    })[0];
    if (title && active) title.textContent = active.textContent;
    if (countEl) countEl.textContent = count + ' ' + (count === 1 ? 'article' : 'articles');
  }

  var requested = new URLSearchParams(window.location.search).get('topic');
  var match = buttons.filter(function (b) {
    return b.dataset.journalKey === requested;
  })[0];
  if (match) applyFilter(Number(match.dataset.journalFilter));

  buttons.forEach(function (button) {
    button.addEventListener('click', function () {
      applyFilter(Number(button.dataset.journalFilter));
    });
  });
})();
